import React from 'react';
import { Fingerprint } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-noir-bg border-b border-noir-border relative overflow-hidden" data-id="element-115">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl relative z-10" data-id="element-116">
        <div className="bg-noir-card border border-noir-border p-8 md:p-12 rounded-sm relative" data-id="element-117">
          {/* Decorative corners */}
          <div className="absolute top-0 left-0 w-4 h-4 border-t border-l border-noir-muted" data-id="element-118"></div>
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b border-r border-noir-muted" data-id="element-119"></div>

          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-120">
            <div className="flex-shrink-0" data-id="element-121">
              <div className="w-24 h-24 bg-noir-bg border border-noir-border rounded-sm flex items-center justify-center" data-id="element-122">
                <Fingerprint className="w-12 h-12 text-noir-alert opacity-80" data-id="element-123" />
              </div>
            </div>

            <div data-id="element-124">
              <h2 className="text-2xl md:text-3xl font-mono font-bold text-noir-text mb-4 uppercase" data-id="element-125">
                El Mecanismo:{' '}
                <span className="text-noir-alert" data-id="element-126">Proyección por Casos</span>
              </h2>
              <p className="text-noir-muted mb-4" data-id="element-127">
                "Expediente Pareja" no es un libro, es un juego de
                investigación. Al analizar los errores, secretos y "metidas de
                pata" de otras parejas, ustedes bajan la guardia.
              </p>
              <p className="text-noir-text text-sm font-mono border-l-2 border-noir-alert pl-4 py-1 bg-noir-bg/50" data-id="element-128">
                Es científicamente más fácil identificar una solución en la vida
                de otro que en la propia. Al resolver el misterio externo, el
                cerebro encuentra el camino para sanar el conflicto interno sin
                peleas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}